export default {
  loginMsg: "",
  isMask: false,
  config: "",
  deviceConfig: "",
  carNo: "",
  icCard: '',
  idCardInfo: '',
  currentBill: '',
  printMsg: '',  //planOut:提单打印地址 exit:出门条打印地址 pay:支付打印地址
  carMainMsg:'',
  costMsg:'',
  costChoose:'',
  payList:'',
  faceImg:'',
  SSeInfo: {
    usedLocation_1f: [],
    usedLocation_2f: [],
    usedLocation_3f: [],
    locationPalletCount: {},
    todayInAndOut: {},
    inStorageCount: {},
    qualityStorageCount: {},
    thermometryCount: {},
    efficiencyCount: {},
    businessCount: {}
  },
  warehouseFloor: '1f'
}




// WEBPACK FOOTER //
// ./src/store/state.js